import React from 'react'
import { compose } from 'redux'
import { isRichTextEmpty } from '../../../lib/richText'
import { withInjectParams } from '../../utils/InjectParams'
import withStyles from 'constructicon/with-styles'
import styles from './styles'
import Buttons from '../../ui/Buttons'
import RichText from '../../ui/RichText'

const CTAs = ({
  injectParams,
  items,
  styles,
  title
}) => {
  const buttons = items.map(item => ({
    ...item,
    label: injectParams(item.label),
    url: injectParams(item.url)
  }))

  return (
    <div>
      {!isRichTextEmpty(title) && (
        <RichText styles={styles.title}>
          {title}
        </RichText>
      )}
      <Buttons buttons={buttons} />
    </div>
  )
}

export default compose(
  withInjectParams,
  withStyles(styles)
)(CTAs)
